import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';

function* fetchQualificationsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_JOB_SETUP_QUALIFICATIONS, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch qualifications!');
    }

    yield put({ type: types.FETCH_JOB_SETUP_QUALIFICATIONS_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.FETCH_JOB_SETUP_QUALIFICATIONS_FAILURE, payload: error });
  }
}

function* saveQualificationSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_JOB_SETUP_JOB_SETUP_QUALIFICATIONS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save qualification!');
    }

    yield put({ type: types.SAVE_JOB_SETUP_QUALIFICATION_SUCCESS });

    Swal.fire({
      title: 'Success',
      text: 'Qualification saved successfully!',
      icon: 'success',
      confirmButtonText: 'OK',
    });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_JOB_SETUP_QUALIFICATION_FAILURE, payload: error });
  }
}

function* changeQualificationStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_CHANGE_JOB_SETUP_QUALIFICATIONS_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_SUCCESS });

    Swal.fire({
      title: 'Success',
      text: 'Status updated!',
      icon: 'success',
      confirmButtonText: 'OK',
    });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_FAILURE, payload: error });
  }
}

export default function* qualificationsSaga() {
  yield takeLatest(types.FETCH_JOB_SETUP_QUALIFICATIONS_REQUEST, fetchQualificationsSaga);
  yield takeLatest(types.SAVE_JOB_SETUP_QUALIFICATION_REQUEST, saveQualificationSaga);
  yield takeLatest(types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_REQUEST, changeQualificationStatusSaga);
}
